export const HEALER_MP_SIM_STUB_NAME = "mp-sim";
